import React from 'react';
import styled, { css } from 'styled-components';
import { Column } from '../../global/grid/grid';
import colors from '../../../vars/colors';
import breakpoints from '../../../vars/breakpoints';
import gutters from '../../../vars/gutters';

const CarouselButton = styled.div`
    position: absolute;
    width: 90px;
    height: 70px;
    background-color: ${props => props.color === 'red' ? colors['lipstick'] : colors['peacock-blue']};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.3s;
    div {
        border: solid white;
        border-width: 0 5px 5px 0;
        display: inline-block;
        padding: 10px;
        transform-origin: center center;
    }
    &:hover {
        background-color: ${props => props.color === 'red' ? '#e5334b' : '#0076ab'}
    }
    @media (max-width: ${breakpoints['bp-tablet']}) {
        width: 60px;
        height: 46px;
    }
`;

export const IncrementButton = styled(CarouselButton)`
    right: -25px;
    top: calc(50% - 35px);
    @media (max-width: ${breakpoints['bp-mobile']}) {
        top: calc(60%);
    }
    div {
        margin-right: 5px;
        transform: rotate(-45deg);
        @media (max-width: ${breakpoints['bp-tablet']}) {
            padding: 7px;
        }
    }
`;

export const DecrementButton = styled(CarouselButton)`
    left: -25px;
    top: calc(50% - 35px);
    @media (max-width: ${breakpoints['bp-mobile']}) {
        top: calc(60%);
    }
    div {
        margin-left: 5px;
        transform: rotate(135deg);
        @media (max-width: ${breakpoints['bp-tablet']}) {
            padding: 7px;
        }
    }    
`;

export const ColorBlock = styled.div`
    position: absolute;
    bottom: 25%;
    overflow: hidden;
    ${props => props.direction === 'left' && css`
        left: calc(${gutters['container-gutters-desktop-l']} * -0.8);   
    `
    }
    ${props => props.direction === 'right' && css`
        right: calc(${gutters['container-gutters-desktop-l']} * -0.8);   
    `
    }
    top: calc(${gutters['container-gutters-desktop-l']} * -0.7);
    z-index: -1;
    width: 80%;
    @media (max-width: ${breakpoints['bp-desktop']}) {
        ${props => props.direction === 'left' && css`
            left: calc(${gutters['container-gutters-desktop']} * -0.8);
        `
        }
        ${props => props.direction === 'right' && css`
            right: calc(${gutters['container-gutters-desktop']} * -0.8);
        `
        }
        top: calc(${gutters['container-gutters-desktop']} * -0.7);
    }
    @media (max-width: ${breakpoints['bp-tablet']}) {
        ${props => props.direction === 'left' && css`
            left: calc(${gutters['container-gutters-tablet']} * -0.8);   
        `
        }
        ${props => props.direction === 'right' && css`
            right: calc(${gutters['container-gutters-tablet']} * -0.8);   
        `
        }        
        top: calc(${gutters['container-gutters-tablet']} * -0.7);
    }
    @media (max-width: ${breakpoints['bp-mobile']}) {
        ${props => props.direction === 'left' && css`
            left: calc(${gutters['container-gutters-mobile']} * -0.8);   
        `
        }
        ${props => props.direction === 'right' && css`
            right: calc(${gutters['container-gutters-mobile']} * -0.8);
        `
        }        
        top: calc(${gutters['container-gutters-mobile']} * -0.7);
    }
    .stripes {
        background: repeating-linear-gradient(-45deg, ${props => props.color === 'red' ? colors['lipstick'] : colors['peacock-blue']}, ${props => props.color === 'red' ? colors['lipstick'] : colors['peacock-blue']} 25px, rgba(255, 255, 255, 0.5) 25px, rgba(255, 255, 255, 0.5) 50px);
        position: absolute;
        top: -75px;
        left: -75px;
        right: -75px;
        bottom: -75px;        
        animation-name: barbersPole;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
        animation-duration: 1200ms;
        animation-play-state: running;
        @keyframes barbersPole {
            0% {transform: translate3d(0, 0, 0)}
            100% {transform: translate3d(0, 72px, 0)}
        }
    }
`;

export const Copy = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    position: absolute;
    .city {
        font-family: 'OneDotExt', sans-serif;
        font-weight: bold;
        font-size: 40px;
        color: ${props => props.color === 'red' ? colors['lipstick'] : colors['peacock-blue']};
        text-transform: uppercase;
        margin-top: 40px;
        @media (max-width: ${breakpoints['bp-mobile']}) {
            font-size: 30px;
        }
    }
    .state {
        font-family: 'OneDot', sans-serif;
        font-size: 25px;
        font-weight: bold;
        letter-spacing: 3px;
        text-transform: uppercase;
        margin-top: 10px;
        @media (max-width: ${breakpoints['bp-mobile']}) {
            font-size: 16px;
        }
    }
    .initialsHolder {
        font-family: 'OneDotCd', sans-serif;
        font-weight: bold;
        color: ${colors['white-two']};
        position: absolute;
        top: 0;
        width: 100%;
        font-size: 400px;
        display: flex;
        align-items: center;
        justify-content: center;
        letter-spacing: 10px;
        z-index: -1;
        text-transform: uppercase;
        margin-top: -10%;
        @media (max-width: ${breakpoints['bp-desktop']}) {
            font-size: 300px;
        }
        @media (max-width: ${breakpoints['bp-tablet']}) {
            font-size: 250px;
        }
        @media (max-width: ${breakpoints['bp-mobile']}) {
            display: none;
        }
    }
    @media (max-width: ${breakpoints['bp-mobile']}) {
        position: relative;
        margin-bottom: 30px;
    }
`;

export const DataCounter = styled.div`
    z-index: 3;
    position: absolute;
    bottom: -55px;
    ${props => props.direction === 'left' && css`
        left: 40px;
        `
    }       
    ${props => props.direction === 'right' && css`
        right: 40px;
        `
    }
    @media (max-width: ${breakpoints['bp-mobile']}) {
        bottom: -40px;
    }
    .circleLabel {                        
        animation-name: spinCircle;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
        animation-duration: 10000ms;
        animation-play-state: running;
        @keyframes spinCircle {
            0% {transform: rotate(0deg)}
            100% {transform: rotate(360deg)}
        }
    }
`;

export const CarouselHolder = styled(Column)`
    @media (max-width: ${breakpoints['bp-mobile']}) {
        order: 2;
    }
    &:hover {
        .circleLabel {
            animation-play-state: paused;
        }
        .stripes {
            animation-play-state: paused;
        }
    }
`;

export const CopyHolder = styled(Column)`
    @media (max-width: ${breakpoints['bp-mobile']}) {
        order: 1;
    }    
`;


// WEBPACK FOOTER //
// ./src/components/modules/Carousel/styled-components.js